import { NavLink } from 'react-router';
import { cn } from '@/lib/cn';
import { MOBILE_TAB_ITEMS } from './navItems';
import { hapticNav } from '@/features/lifecycle/haptics';
import { useUIStore } from '@/stores/uiStore';

export function BottomTabs() {
  // Native keyboard replaces the tab bar (standard iOS). The WebView already
  // shrinks above the keyboard (resize: 'native'), so a visible bar would sit
  // directly above it eating typing space — and lifting it by
  // --keyboard-height double-compensates and strands it mid-screen.
  const keyboardVisible = useUIStore((s) => s.keyboardVisible);
  if (keyboardVisible) return null;

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-bar flex items-stretch border-t border-line-2 bg-canvas pb-[env(safe-area-inset-bottom)]"
      aria-label="Primary"
    >
      {MOBILE_TAB_ITEMS.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/app'}
            onClick={() => {
              void hapticNav();
            }}
            className="flex min-h-14 flex-1 flex-col items-center justify-center gap-1 px-1 pb-1.5 pt-1.5 text-eyebrow tracking-normal font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand"
          >
            {({ isActive }) => (
              <>
                {/* 100+/day nav — motion budget says no animation; snap. */}
                <span
                  className={cn(
                    'flex h-7 w-12 items-center justify-center rounded-full',
                    isActive ? 'bg-brand-soft text-brand-ink' : 'text-t2',
                  )}
                >
                  <Icon className="h-5 w-5" aria-hidden />
                </span>
                <span className={cn(isActive ? 'font-semibold text-t1' : 'text-t2')}>
                  {item.label}
                </span>
              </>
            )}
          </NavLink>
        );
      })}
    </nav>
  );
}
